import { render, staticRenderFns } from "./Vision.vue?vue&type=template&id=3c59ee58&scoped=true&"
import script from "./Vision.vue?vue&type=script&lang=ts&"
export * from "./Vision.vue?vue&type=script&lang=ts&"
import style0 from "./Vision.vue?vue&type=style&index=0&id=3c59ee58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c59ee58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c59ee58')) {
      api.createRecord('3c59ee58', component.options)
    } else {
      api.reload('3c59ee58', component.options)
    }
    module.hot.accept("./Vision.vue?vue&type=template&id=3c59ee58&scoped=true&", function () {
      api.rerender('3c59ee58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/nihss/v2/Vision.vue"
export default component.exports